/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ListToolUsageTracesPayload,
  ListToolUsageTracesPayload$Outbound,
  ListToolUsageTracesPayload$outboundSchema,
} from "../components/listtoolusagetracespayload.js";

export type ListToolUsageTracesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListToolUsageTracesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListToolUsageTracesSecurity = {
  option1?: ListToolUsageTracesSecurityOption1 | undefined;
  option2?: ListToolUsageTracesSecurityOption2 | undefined;
};

export type ListToolUsageTracesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  listToolUsageTracesPayload: ListToolUsageTracesPayload;
};

/** @internal */
export type ListToolUsageTracesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListToolUsageTracesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListToolUsageTracesSecurityOption1$Outbound,
  ListToolUsageTracesSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listToolUsageTracesSecurityOption1ToJSON(
  listToolUsageTracesSecurityOption1: ListToolUsageTracesSecurityOption1,
): string {
  return JSON.stringify(
    ListToolUsageTracesSecurityOption1$outboundSchema.parse(
      listToolUsageTracesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListToolUsageTracesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListToolUsageTracesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListToolUsageTracesSecurityOption2$Outbound,
  ListToolUsageTracesSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listToolUsageTracesSecurityOption2ToJSON(
  listToolUsageTracesSecurityOption2: ListToolUsageTracesSecurityOption2,
): string {
  return JSON.stringify(
    ListToolUsageTracesSecurityOption2$outboundSchema.parse(
      listToolUsageTracesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListToolUsageTracesSecurity$Outbound = {
  Option1?: ListToolUsageTracesSecurityOption1$Outbound | undefined;
  Option2?: ListToolUsageTracesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListToolUsageTracesSecurity$outboundSchema: z.ZodMiniType<
  ListToolUsageTracesSecurity$Outbound,
  ListToolUsageTracesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListToolUsageTracesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListToolUsageTracesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listToolUsageTracesSecurityToJSON(
  listToolUsageTracesSecurity: ListToolUsageTracesSecurity,
): string {
  return JSON.stringify(
    ListToolUsageTracesSecurity$outboundSchema.parse(
      listToolUsageTracesSecurity,
    ),
  );
}

/** @internal */
export type ListToolUsageTracesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ListToolUsageTracesPayload: ListToolUsageTracesPayload$Outbound;
};

/** @internal */
export const ListToolUsageTracesRequest$outboundSchema: z.ZodMiniType<
  ListToolUsageTracesRequest$Outbound,
  ListToolUsageTracesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    listToolUsageTracesPayload: ListToolUsageTracesPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      listToolUsageTracesPayload: "ListToolUsageTracesPayload",
    });
  }),
);

export function listToolUsageTracesRequestToJSON(
  listToolUsageTracesRequest: ListToolUsageTracesRequest,
): string {
  return JSON.stringify(
    ListToolUsageTracesRequest$outboundSchema.parse(listToolUsageTracesRequest),
  );
}
